module.exports = __webpack_public_path__ + "img/tree_1_4.23a6ef8b.png";